import Filter from "./Filter";
import LastOrders from "./LastOrders";
import List from "./List";

export default {
    Filter,
    LastOrders,
    List
}